import csCZTranslations from './cs-CZ'
import skSKTranslations from './sk-SK'
import enGBTranslations from './en-GB'

export default {
    'cs-CZ': csCZTranslations,
    'sk-SK': skSKTranslations,
    'en-GB': enGBTranslations,
}